import {ChannelType} from "../../../Types/ChannelType";

export type MinimumOrderQuantityProduct = {
    moqHurt: number;
    moqShop: number;
    quantity: number;
    quantityPackage: number;
};

export function isMinimumOrderQuantityEnabled(channel: ChannelType | null): boolean {
    return channel?.orderMoq === true && (channel.moqType === 'HURT' || channel.moqType === 'DETAIL' || channel.moqType === 'SHOP');
}

export function getMinimumOrderQuantity(
    product: MinimumOrderQuantityProduct,
    channel: ChannelType | null
): number | null {
    if (!isMinimumOrderQuantityEnabled(channel)) {
        return null;
    }

    const productMoq = getProductMinimumOrderQuantity(product, channel);

    if (productMoq === null || product.quantity < productMoq) {
        return product.quantityPackage;
    }

    return productMoq;
}

export function getProductMinimumOrderQuantity(
    product: MinimumOrderQuantityProduct,
    channel: ChannelType | null
): number | null {
    if (!isMinimumOrderQuantityEnabled(channel)) {
        return null;
    }

    const productMoq = channel?.moqType === 'HURT' ? product.moqHurt : product.moqShop;

    return productMoq > 0 ? productMoq : null;
}

export function isMinimumOrderQuantityApplicable(
    product: MinimumOrderQuantityProduct,
    channel: ChannelType | null
): boolean {
    const productMoq = getProductMinimumOrderQuantity(product, channel);

    return productMoq !== null && product.quantity >= productMoq;
}
